import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Button from '../ui/Button';
import './AuthPages.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

export default function NewPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password || password.length < 6) {
      setError('Пароль должен быть не менее 6 символов');
      return;
    }
    if (password !== password2) {
      setError('Пароли не совпадают');
      return;
    }
    setLoading(true);
    setError('');

    try {
      const res = await fetch(`${API_URL}/auth/new-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (data.success) {
        setSuccess(true);
      } else {
        setError(data.error || 'Ошибка');
      }
    } catch (e) {
      setError('Ошибка соединения');
    }
    setLoading(false);
  };

  if (!token) {
    return (
      <div className="auth-centered">
        <div className="auth-icon">❌</div>
        <h2 className="auth-heading">Ссылка недействительна</h2>
        <div style={{ height: 24 }} />
        <Button variant="blue" style={{ width: '80%' }} onClick={() => navigate('/reset-password')}>
          Запросить сброс заново
        </Button>
      </div>
    );
  }

  if (success) {
    return (
      <div className="auth-centered">
        <div className="auth-icon">✅</div>
        <h2 className="auth-heading">Пароль изменён!</h2>
        <p className="auth-text">Теперь вы можете войти с новым паролем</p>
        <div style={{ height: 24 }} />
        <Button variant="blue" style={{ width: '80%' }} onClick={() => navigate('/login')}>
          Войти
        </Button>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <form className="auth-form" onSubmit={handleSubmit}>
        <div className="auth-logo">
          <img src="/logo-icon.png" alt="" style={{ width: 80, height: 80, borderRadius: 20 }} />
        </div>
        <h1 className="auth-title">Новый пароль</h1>
        <p className="auth-subtitle">Придумайте новый пароль</p>

        <input
          className="auth-input"
          type="password"
          placeholder="Новый пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <input
          className="auth-input"
          type="password"
          placeholder="Повторите пароль"
          value={password2}
          onChange={(e) => setPassword2(e.target.value)}
        />
        {error && <div className="auth-error">{error}</div>}
        <div style={{ height: 8 }} />
        <Button variant="accent" disabled={loading}>
          {loading ? 'Сохраняем...' : 'Сохранить пароль'}
        </Button>
      </form>
    </div>
  );
}
